export class PricingDetailFocusView {
    public tree: boolean = false;
    public detailGeneral: boolean = false;
    public attributesAndRules: boolean = false;
    public text: boolean = false;
    public media: boolean = false;
    public translation: boolean = false;
}